import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import Box from "@mui/material/Box";

// sx styles (migrated from JSS cardFooterStyle.js — Faz 7)
const cardFooterSx = {
  display: "flex",
  alignItems: "center",
  backgroundColor: "transparent",
  padding: "0.9375rem 1.875rem"
};

export default function CardFooter(props) {
  const { className, children, ...rest } = props;
  return (
    <Box className={className} sx={cardFooterSx} {...rest}>
      {children}
    </Box>
  );
}

CardFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
